import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  meta?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  action,
  meta
}: PageHeaderProps) {
  return <div className="flex flex-wrap items-end justify-between gap-4 mb-5" data-id="element-328" data-mp="1me4d45wffq7l">
      <div data-id="element-329" data-mp="1r6fdf9v2xe0o">
        <h1 className="font-display text-xl font-bold tracking-tight text-slate-900" data-id="element-330" data-mp="1r65l3fmkaurt">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500" data-id="element-331" data-mp="1w3xfcgaoisz6">{subtitle}</p>}
        {meta}
      </div>
      {action && <div className="flex items-center gap-2" data-id="element-332" data-mp="212s5y4ew1ltu">{action}</div>}
    </div>;
}